module.exports = __webpack_public_path__ + "img/pic_head portrait_sign in@2x.ea491be2.png";